module.exports = __webpack_public_path__ + "img/党建品牌建设-块面点击-迅捷压缩.6babaa19.png";